import type { TeamRoleDetails as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Allowance from './Allowance';
import * as PermissionGroup from './PermissionGroup';

/**
 * The full role definition the editor renders: every permission grouped by area, plus the flat
 * allowance toggles. All four fields are non-null on AppSchema, so the type says so — the
 * admin-local type this replaces had them optional and omitted `allowances` entirely, even
 * though the editor renders a toggle per allowance.
 *
 * The `?? []` fallbacks below are defence against a malformed payload, not a schema-permitted
 * absence: `permissionGroups`, `allowances`, `permissions` and `options` are all `[T!]!`.
 */
export type TeamRoleDetails = {
  id: number;
  name: string;
  permissionGroups: PermissionGroup.PermissionGroup[];
  allowances: Allowance.Allowance[];
};

export const fromGql = (item: GQLItem): TeamRoleDetails => ({
  ...take<Pick<TeamRoleDetails, 'id' | 'name'>>(item, 'id', 'name'),
  permissionGroups: item.permissionGroups?.map(PermissionGroup.fromGql) ?? [],
  allowances: item.allowances?.map(Allowance.fromGql) ?? [],
});
